import type { ContentType, Picture, ThemesPicture } from './common'
import type { StoryStatus } from './story'
import type { Topic } from './topic'
import type { User } from './user'

export enum PostStatus {
	NORMAL = 'NORMAL',
	DELETED = 'DELETED',
}

export enum PostAction {
	USER_FOLLOW = 'USER_FOLLOW',
}

export interface LinkInfo {
	title: string
	pictureUrl: string
	linkUrl: string
	source?: string
	linkType?: string
	brandLogoImage?: ThemesPicture
	audio?: Audio
	abstract?: string
}

export interface Audio {
	type: string
	subtype: string
	image: Picture
	title: string
	author: string
}

export interface Poi {
	poiId: string
	name: string
	location: number[]
	countryname: string
	pname: string
	cityname: string
	formattedAddress: string
}

export interface ReadTrackInfo {
	loadedAt: number
	feedType: FeedType
	storyStatus?: StoryStatus
}

export enum FeedType {
	FOLLOWING_UPDATES = 'FOLLOWING_UPDATES',
}

export type PostType = ContentType.POST | ContentType.REPOST | ContentType.PERSONAL_UPDATE

export interface StatsCount {
	topicSubscribed: number
	topicCreated: number
	followedCount: number
	followingCount: number
	highlightedPersonalUpdates: number
	liked: number
	respectedCount: number
}

export interface Rollouts {
	wmpShare: WmpShare
}

export interface WmpShare {
	id: string
	path: string
}

export interface UrlsInText {
	title: string
	originalUrl: string
	url: string
	type: UrlsInTextType
}

export enum UrlsInTextType {
	LINK = 'link',
	MENTION = 'mention',
}

export interface Post {
	id: string
	type: PostType
	actionTime?: string
	createdAt: string
	updateIds?: string[]
	action?: PostAction
	usernames?: string[]
	targetUsernames?: string[]
	users?: User[]
	targetUsers?: User[]
	readTrackInfo?: ReadTrackInfo
	content: string
	rawContent?: string
	urlsInText: UrlsInText[]
	status?: PostStatus
	user?: User
	target?: Post
	targetType?: PostType
	rootType?: PostType
	topEndowers?: any[]
	hasMoreEndower?: boolean
	commentCount?: number
	repostCount?: number
	likeCount?: number
	shareCount?: number
	pictures?: Picture[]
	liked?: boolean
	deleted?: boolean
	collected?: boolean
	enablePictureComments?: boolean
	repostable?: boolean
	isCommentForbidden?: boolean
	topic?: Topic
	collectTime?: null
	isFeatured?: boolean
	isPrivate?: boolean
	isSuppressed?: boolean
	rollouts?: Rollouts
	likeIcon?: string
	syncCommentId?: string
	replyToComment?: Comment
	editableStatus: 'DISABLED' | 'ENABLED'
	editedAt?: string
	recordId?: string
	linkInfo?: LinkInfo
	poi?: Poi
	pinned?: {
		personalUpdate?: boolean
	}
	privatizableStatus?: 'ENABLE_HIDE' | 'ENABLE_RECOVER'
	video?: {
		duration: number
		source: string[]
		thumbnailUrl: string
		type: 'VIDEO'
	}
}
